import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "steps__step-number" }
const _hoisted_2 = { class: "steps__step-title-wrapper" }
const _hoisted_3 = { class: "steps__step-title" }
const _hoisted_4 = {
  key: 0,
  class: "steps__step-summary"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { key: 4 }
const _hoisted_10 = { key: 5 }
const _hoisted_11 = { key: 6 }
const _hoisted_12 = { key: 7 }
const _hoisted_13 = { key: 8 }
const _hoisted_14 = { class: "pre-wrap" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["steps__step", ( $setup.is_completed_step ) ? ' steps__step--completed' : ( $setup.is_current_step ) ? ' steps__step--active' : null])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString($props.step.step_number), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString($props.step.title), 1 /* TEXT */),
      ($setup.is_completed_step)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
            ($setup.form_fields.project_name)
              ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                  _createTextVNode(" Project Name: "),
                  _createElementVNode("span", null, _toDisplayString($setup.form_fields.project_name), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            ($setup.form_fields.pandadoc_fee_proposal)
              ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                  _createTextVNode(" Link to PandaDoc Fee Proposal: "),
                  _createElementVNode("span", null, _toDisplayString($setup.form_fields.pandadoc_fee_proposal), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            ($setup.form_fields.project_type)
              ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                  _createTextVNode(" Project Type: "),
                  _createElementVNode("span", null, _toDisplayString($setup.label_project_type), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            ($setup.form_fields.project_location)
              ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                  _createTextVNode(" Project Location: "),
                  _createElementVNode("span", null, _toDisplayString($setup.selected_project_location.title), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            ($setup.form_fields.project_coordinates)
              ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                  _createTextVNode(" Project Coordinates: "),
                  _createElementVNode("span", null, _toDisplayString($setup.form_fields.project_coordinates), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            ($setup.form_fields.intended_use)
              ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                  _createTextVNode(" Intended Use: "),
                  _createElementVNode("span", null, _toDisplayString($setup.selected_intended_use.label), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            ($setup.form_fields.kick_off)
              ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                  _createTextVNode(" Kick off date: "),
                  _createElementVNode("span", null, _toDisplayString($setup.format_date( $setup.form_fields.kick_off )), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            ($setup.form_fields.completion_date)
              ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                  _createTextVNode(" Target completion date: "),
                  _createElementVNode("span", null, _toDisplayString($setup.format_date( $setup.form_fields.completion_date )), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            ($setup.form_fields.project_description)
              ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                  _createTextVNode(" Project Description: "),
                  _createElementVNode("span", _hoisted_14, _toDisplayString($setup.form_fields.project_description), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    ($setup.is_completed_step)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "button button--smaller",
          type: "button",
          onClick: _cache[0] || (_cache[0] = $event => ($setup.setActiveStep( $props.step.step_number )))
        }, " Edit "))
      : ($setup.is_current_step)
        ? (_openBlock(), _createBlock($setup["ProjectDetailsFormComponent"], {
            key: 1,
            "step-title": $props.step.title
          }, null, 8 /* PROPS */, ["step-title"]))
        : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}